export default "__VITE_ASSET__DGgcUu0F__"